var map = {
	"./manonyfox1.png": 8891,
	"./manonyfox10.png": 9859,
	"./manonyfox11.png": 1002,
	"./manonyfox12.png": 9985,
	"./manonyfox13.png": 5368,
	"./manonyfox14.png": 6887,
	"./manonyfox15.png": 3870,
	"./manonyfox16.png": 5669,
	"./manonyfox17.png": 6252,
	"./manonyfox2.png": 1328,
	"./manonyfox3.png": 5529,
	"./manonyfox4.png": 5558,
	"./manonyfox5.png": 9359,
	"./manonyfox6.png": 4084,
	"./manonyfox7.png": 7325,
	"./manonyfox8.png": 4442,
	"./manonyfox9.png": 4275
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6341;